var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "mb-3" }, [
      _vm._v("Final revision! Double check before saving :)"),
    ]),
    _vm._v(" "),
    _c("li", [
      _vm._v("\n        Product: "),
      _c("b", [_vm._v(_vm._s(_vm.productTitle))]),
    ]),
    _vm._v(" "),
    _c("li", [_vm._v("Selected placeholders:")]),
    _vm._v(" "),
    _c(
      "ul",
      { staticStyle: { "max-height": "500px", "overflow-y": "auto" } },
      [
        _setup.props.podService == "printify"
          ? _vm._l(_setup.props.providerVariants, function (provider) {
              return _c(
                "li",
                { key: provider.printProviderId, staticClass: "mb-2" },
                [
                  _c("b", [
                    _vm._v(
                      'Print provider: "' +
                        _vm._s(provider.printProviderName) +
                        '"'
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(provider.variants, function (variant) {
                      return _c("li", { key: variant.variantId }, [
                        _c("b", [_vm._v(_vm._s(variant.variantName))]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(variant.placeholders, function (ph, index) {
                            return _c("li", { key: index }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-transform": "capitalize",
                                  },
                                },
                                [_vm._v(_vm._s(ph))]
                              ),
                            ])
                          }),
                          0
                        ),
                      ])
                    }),
                    0
                  ),
                ]
              )
            })
          : _setup.props.providerVariants?.length
          ? _vm._l(
              _setup.props.providerVariants[0].variants,
              function (variant) {
                return _c("li", { key: variant.variantId }, [
                  _c("b", [_vm._v(_vm._s(variant.variantName))]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(variant.placeholders, function (ph, index) {
                      return _c("li", { key: index }, [
                        _c(
                          "div",
                          { staticStyle: { "text-transform": "capitalize" } },
                          [_vm._v(_vm._s(ph))]
                        ),
                      ])
                    }),
                    0
                  ),
                ])
              }
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }